import type { ILocationV2 } from '@sravni/types/lib/locations';

import { getCenters, getCurrentLocation, getRegions } from '../selectors/locations';

import { useAppSelector } from './redux';

export const useRegions = () => useAppSelector(getRegions);
export const useCenters = () => useAppSelector(getCenters);

export const useAllLocations = (): ILocationV2[] => {
  const centers = useCenters();
  const regions = useRegions();

  return Object.values({ ...regions, ...centers });
};

export function useCurrentRegion(): ILocationV2 {
  return useAppSelector(getCurrentLocation);
}
